import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/HomePage.vue'),
    },
    {
        path: '/pricing',
        name: 'pricing',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/RequestDemoPage.vue'),
    },
    {
        path: '/support',
        name: 'support',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/SupportPage.vue'),
    },
    {
        path: '/about',
        name: 'about',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/AboutPage.vue'),
    },
    {
        path: '/privacy',
        name: 'privacy',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/PrivacyPage.vue'),
    },
    {
        path: '/terms',
        name: 'terms',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/TermsPage.vue'),
    },
    {
        path: '/contact',
        name: 'contact',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/ContactPage.vue'),
    },
    {
        path: '/resources/haulingcalc',
        name: 'haulingCalculatorMenu',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/resources/HaulingCalculatorMenuPage.vue'),
    },
    {
        path: '/resources/haulingcalc/give',
        name: 'haulingCalculatorGive',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/resources/HaulingCalculatorGivePage.vue'),
    },
    {
        path: '/resources/haulingcalc/analyze',
        name: 'haulingCalculatorAnalyze',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/resources/HaulingCalculatorAnalyzePage.vue'),
    },
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/LoginPage.vue'),
        meta: { requireGuest: true },
    },
    {
        path: '/login/forgot',
        name: 'forgotPassword',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/ForgotPasswordPage.vue'),
    },
    {
        path: '/driver/welcome',
        name: 'driverWelcome',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/DriverWelcomePage.vue'),
    },
    {
        path: '/login/reset',
        name: 'resetPassword',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/ResetPasswordPage.vue'),
    },
    {
        path: '/login/driverPassword',
        name: 'driverPassword',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/ResetPasswordPage.vue'),
        props: { title: 'Set Password' },
    },
    {
        path: '/confirmEmailChange',
        name: 'confirmEmailChange',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/ConfirmEmailChange.vue'),
    },
    {
        path: '/signup',
        name: 'signup',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/RequestDemoPage.vue'),
        meta: { requireGuest: true },
    },
    {
        path: '/signup/subscription',
        name: 'signupSubscription',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/signup/SignupSubscriptionPage.vue'),
    },
    {
        path: '/signup/subscription-finalize',
        name: 'SignupSubscriptionFinalize',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/signup/SignupSubscriptionFinalizePage.vue'),
    },
    {
        // Page for generating company reports in iframe
        path: '/company/report',
        name: 'CompanyReport',
        component: () => import(/* webpackChunkName: "company" */ '../views/company/report/components/Report.vue'),
    },
    {
        path: '/company',
        name: 'CompanyLayout',
        component: () => import(/* webpackChunkName: "company" */ '../views/company'),
        children: [
            {
                path: '/',
                redirect: 'dashboard',
            },
            {
                path: 'dashboard',
                name: 'CompanyDashboardPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/CompanyDashboardPage.vue'),
                meta: { requireCompany: true, requireSubscription: true },
            },
            {
                path: 'clients',
                name: 'ClientListPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/client/ClientListPage.vue'),
                meta: { requireCompany: true, requireSubscription: true },
            },
            {
                path: 'clients/:id/edit',
                name: 'ClientEditPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/client/ClientEditPage.vue'),
                meta: { requireCompany: true, requireSubscription: true },
            },
            {
                path: 'clients/create',
                name: 'ClientCreatePage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/client/ClientCreatePage.vue'),
                meta: { requireCompany: true, requireSubscription: true },
            },
            {
                path: 'projects',
                name: 'ProjectListPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/project/ProjectListPage.vue'),
                meta: { requireCompany: true, requireSubscription: true },
            },
            {
                path: 'projects/:id/edit',
                name: 'ProjectEditPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/project/ProjectEditPage.vue'),
                meta: { requireCompany: true, requireSubscription: true },
            },
            {
                path: 'projects/create',
                name: 'ProjectCreatePage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/project/ProjectCreatePage.vue'),
                meta: { requireCompany: true, requireSubscription: true },
            },
            {
                path: 'tickets',
                name: 'TicketListPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/ticket/TicketListPage.vue'),
                meta: { requireCompany: true, requireSubscription: true },
            },
            {
                path: 'tickets/:id/edit',
                name: 'TicketEditPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/ticket/TicketEditPage.vue'),
                meta: { requireCompany: true, requireSubscription: true },
            },
            {
                path: 'tickets/create',
                name: 'TicketCreatePage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/ticket/TicketCreatePage.vue'),
                meta: { requireCompany: true, requireSubscription: true },
            },
            {
                path: 'drivers',
                name: 'DriverListPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/driver/DriverListPage.vue'),
                meta: { requireCompany: true, requireSubscription: true },
            },
            {
                path: 'drivers/:id/edit',
                name: 'DriverEditPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/driver/DriverEditPage.vue'),
                meta: { requireCompany: true, requireSubscription: true },
            },
            {
                path: 'drivers/create',
                name: 'DriverCreatePage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/driver/DriverCreatePage.vue'),
                meta: { requireCompany: true, requireSubscription: true },
            },
            {
                path: 'managers',
                name: 'ManagerListPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/manager/ManagerListPage.vue'),
                meta: { requireCompany: true, requireSubscription: true },
            },
            {
                path: 'managers/:id/edit',
                name: 'ManagerEditPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/manager/ManagerEditPage.vue'),
                meta: { requireCompany: true, requireSubscription: true },
            },
            {
                path: 'managers/create',
                name: 'ManagerCreatePage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/manager/ManagerCreatePage.vue'),
                meta: { requireCompany: true, requireSubscription: true },
            },
            {
                path: 'vehicles',
                name: 'VehicleListPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/vehicle/VehicleListPage.vue'),
                meta: { requireCompany: true, requireSubscription: true },
            },
            {
                path: 'vehicles/:id/edit',
                name: 'VehicleEditPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/vehicle/VehicleEditPage.vue'),
                meta: { requireCompany: true, requireSubscription: true },
            },
            {
                path: 'vehicles/create',
                name: 'VehicleCreatePage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/vehicle/VehicleCreatePage.vue'),
                meta: { requireCompany: true, requireSubscription: true },
            },
            {
                path: 'materials',
                name: 'MaterialListPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/material/MaterialListPage.vue'),
                meta: { requireCompany: true, requireSubscription: true },
            },
            {
                path: 'materials/:id/edit',
                name: 'MaterialEditPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/material/MaterialEditPage.vue'),
                meta: { requireCompany: true, requireSubscription: true },
            },
            {
                path: 'materials/create',
                name: 'MaterialCreatePage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/material/MaterialCreatePage.vue'),
                meta: { requireCompany: true, requireSubscription: true },
            },
            {
                path: 'reports',
                name: 'ReportListPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/report/ReportListPage.vue'),
                meta: { requireCompany: true, requireSubscription: true },
            },
            {
                path: 'reports/view',
                name: 'ReportViewPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/report/ReportViewPage.vue'),
                meta: { requireCompany: true, requireSubscription: true },
            },
            {
                path: 'settings',
                name: 'SettingsPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/settings/SettingsPage.vue'),
                meta: { requireCompany: true },
            },
            {
                path: 'admin',
                name: 'AdminSettingsPage',
                component: () => import(/* webpackChunkName: "admin" */ '../views/company/admin/AdminSettingsPage.vue'),
                meta: { requireCompany: true, requireAdmin: true },
            },
        ],
    },
    {
        path: '/admin',
        name: 'AdminLayout',
        component: () => import(/* webpackChunkName: "admin" */ '../views/admin'),
        children: [
            {
                path: '/',
                redirect: 'dashboard',
            },
            {
                path: 'dashboard',
                name: 'AdminDashboardPage',
                component: () => import(/* webpackChunkName: "admin" */ '../views/admin/AdminDashboardPage.vue'),
                meta: { requireAdmin: true },
            },
            {
                path: 'companies',
                name: 'CompanyListPage',
                component: () => import(/* webpackChunkName: "admin" */ '../views/admin/CompanyListPage.vue'),
                meta: { requireAdmin: true },
            },
        ],
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    },
});

router.beforeEach(async (to, from, next) => {
    const { user } = store.state.auth;

    if (to.matched.some(record => record.meta.requireGuest)) {
        if (!user) {
            return next();
        }

        return next({ path: '/company/dashboard' });
    }

    if (to.matched.some(record => record.meta.requireCompany)) {
        if (!user || !['manager', 'owner', 'admin'].includes(user.role)) {
            return next({ path: '/login' });
        }

        if (!store.state.company.id) {
            await store.dispatch('company/fetchOverview');
        }

        if (user.role === 'owner' && (!user.stripeCustomerId || !store.state.company.subscription)) {
            return next({ path: '/signup/subscription' });
        }
    }

    if (to.matched.some(record => record.meta.requireSubscription)) {
        if (store.getters['company/subscriptionSuspended'] && user.role !== 'admin') {
            return next({ path: '/company/settings' });
        }
    }

    if (to.matched.some(record => record.meta.requireAdmin)) {
        if (!user || user.role !== 'admin') {
            return next({ path: '/login' });
        }
    }

    next();
});

export default router;
